import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import GeoIcon from '@material-ui/icons/LanguageOutlined';
import OvalIcon from '../../assets/Svg/OvalIcon';

interface IProps {
  text?: string;
  fontSize?: number;
  storyId?: number;
  seasonId?: number;
  hasLeftDot?: boolean;
}

const useStyles = makeStyles(() => ({
  geoWrap: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    '& a': {
      color: 'black',
    },
  },
  ovalIcon: {
    marginRight: 5,
  },
  geoIcon: {
    verticalAlign: 'middle',
  },
  container: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
}));

export const GeoIndicator = (props: IProps) => {
  const classes = useStyles();
  const { text, fontSize, storyId, seasonId, hasLeftDot } = props;

  let crewLink = storyId ? `${process.env.CREW_DEFAULT_URI}/stories/${storyId}` : '';
  crewLink = seasonId ? `${crewLink}/seasons/${seasonId}` : crewLink;

  const textSize = fontSize || 13;
  const iconSize = textSize + 2;
  const countText = crewLink ? (
    <Link href={crewLink} target="_blank" className={classes.container}>
      {text}
    </Link>
  ) : (
    text
  );

  return (
    <span className={classes.container}>
      <span className={classes.geoWrap} style={{ fontSize: textSize }}>
        {hasLeftDot && <OvalIcon />}
        <GeoIcon className={classes.geoIcon} style={{ fontSize: iconSize, marginLeft: hasLeftDot ? 2 : 0 }} />
        <span>({countText})</span>
      </span>
    </span>
  );
};
